import httpClient from "../../../httpClient";
import { API_GROUP_RECREATE } from "../../../config";

export const recreateGroup = {
    recreate: (id) => httpClient.get(API_GROUP_RECREATE + '/' + id),
};
